export enum InvestmentAmountType {
  Primary = 'Primary',
  TopUp = 'TopUp',
}

export default InvestmentAmountType;
